<template>
  <div>
    <el-table
      id="rebateSetTable"
      ref="table"
      :border="true"
      :data="list"
      show-summary
      :summary-method="getSummaries"
      :max-height="tableHeight"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      size="small"
    >
      <el-table-column
        v-for="item in column"
        :prop="item.key"
        :label="item.name"
        :key="item.name"
        align="center"
        :width="column.length > 15 ? item.width : ''"
      >
        <template slot="header" v-if="item.iconshow">
          <span
            >{{ item.name }}
            <el-tooltip
              effect="dark"
              :content="item.message"
              placement="top-start"
            >
              <i class="el-icon-info"></i> </el-tooltip
          ></span>
        </template>
        <el-table-column
          :prop="item.key"
          :label="`${item.value}${item.percent ? item.percent : ''}`"
          :width="item.width"
          :key="item.name"
          align="center"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row[item.key] ? item.unit : null
              }}{{ scope.row[item.key] ? scope.row[item.key] : "-"
              }}{{ scope.row[item.key] ? item.percent : null }}</span
            >
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <!-- <el-table
      v-show="false"
      :border="true"
      id="rebateSetTable"
      :data="downloadList"
      ref="table"
      show-summary
      :summary-method="getSummaries"
      :height="tableHeight"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      size="small"
    >
      <el-table-column
        v-for="item in downColunm"
        :prop="item.key"
        :label="item.name"
        :key="item.name"
        align="center"
        :width="downColunm.length > 15 ? item.width : ''"
      >
        <el-table-column
          :prop="item.key"
          :label="item.value + ''"
          :width="item.width"
          :key="item.name"
          align="center"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row[item.key] ? item.unit : null
              }}{{ scope.row[item.key] ? scope.row[item.key] : "-"
              }}{{ scope.row[item.key] ? item.percent : null }}</span
            >
          </template>
        </el-table-column>
      </el-table-column>
    </el-table> -->
  </div>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
// import { sumArr } from "../../utils/tool";
import { sumData } from "../../config/table_comlun";
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 260,
    };
  },

  props: {
    list: Array,
    column: Array,
    loading: Boolean,
    totalColumn: Array,
    // downloadList: {
    //   type: Array,
    //   default: () => [],
    // },
    downColunm: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    downLoadFileToExcel() {
      this.$nextTick(() => {
        let fix = document.querySelector(".el-table__fixed");
        var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
        let wb;
        if (fix) {
          //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
          wb = XLSX.utils.table_to_book(
            document.querySelector("#rebateSetTable").removeChild(fix),
            xlsxParam
          );
          document.querySelector("#rebateSetTable").appendChild(fix);
        } else {
          wb = XLSX.utils.table_to_book(
            document.querySelector("#rebateSetTable"),
            xlsxParam
          );
        }

        let wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "华为报表.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        // console.log(wbout);
        return wbout;
      });
    },

    getSummaries() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      const sums = sumData;
      this.$emit("computTotalColumn", sums);
      return [];
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
}
.el-icon-info {
  cursor: pointer;
}
</style>